// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 493 ? "bf5f3635" : chunkId) + "." + {"493":"be737ecfe9f45c08","534":"371b3c51bd2b74e2"}[chunkId] + ".js";
};